var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customTag-container",style:({color: _vm.color, fontSize: _vm.fontSize + 'px'})},[_c('span',{staticClass:"tag",style:({background: _vm.color})}),_vm._v(_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }